export default __webpack_public_path__ + "static/media/KahshPay.2bec0808.png";